import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { SideBarVM } from '../../Structure/ViewModels/SideBarVM'
import { Router } from '../../Structure/Handlers/Router'
import { Globals } from '../../Structure/Globals/GlobalObs'
import MarketerDetails from '../Marketer/MarketerDetails'
import Accounts from '../Admin/Accounts'
import NoPermissionsPage from '../Admin/NoPermissionsPage'


const SideBar = () => {
    const [vm , setVm] = useState<{viewModel:SideBarVM}>({viewModel:Globals.sideBar})
    useEffect(()=>{ vm.viewModel.subscribeUpdate(setVm) })
    const control = vm.viewModel
    useEffect(()=> { 
        control.getSideTabs()
    },[])
    useEffect(()=> { 
        //Router.OpenMasterPage(control.SideBarPages[9]) 
        if(control.SideBarPages.length > 0)Router.OpenMasterPage(control.SideBarPages[0])
        else Router.OpenNormalPage(<NoPermissionsPage/>) 
    },[control.SideBarPages])
    
    const app = document.getElementById('App') as HTMLDivElement
    if(control.Collapsed){
        if(!app?.classList.contains('sideBar-hide'))app?.classList.add('sideBar-hide')
    }else{
        if(app?.classList.contains('sideBar-hide'))app?.classList.remove('sideBar-hide')
    }


  return (
    <div className={`sideBar bg-I py-2 text-white `}>
        <div className={`sideBar-trigger d-md-none d-block ${control.Collapsed?'sideBar-trigger-flip shadow':''}`} style={{zIndex:'1500px'}}  onClick={()=>control.Collapsed= !control.Collapsed} >
            <FontAwesomeIcon icon={faCaretRight} />
        </div>
        <div className='py-2'>
            <div className='fw-bold text-center fs-1 py-3'>{Globals.auth.User?.name}</div>
            <div className='text-center fs-5'>{Globals.auth.User?.role}</div>
        </div>
        <div className='m-1 py-1 border-bottom border-white'>
            {
                control.SideBarPages.map((item,index)=>(
                    <div key={index} id={item.page} className={`p-3 c-pointer ${control.SelectedPage===item.page?'bg-II':''}`} onClick={()=>{ Router.OpenMasterPage(item) ; control.Collapsed = true}}>{item.page}</div>
                ))
            }
            {/* <div id='1' className={`p-3 c-pointer ${selectedPage===1?'bg-II':''}`} onClick={()=>{ setSelectedPage(1); appBody.Element = <Clients/>}}>العملاء</div>
            <div id='2' className={`p-3 c-pointer ${selectedPage===2?'bg-II':''}`} onClick={()=>setSelectedPage(2)}>اضافة عميل</div> */}
        </div>
        <div className='py-3'>
            <div className={`p-3 c-pointer`} onClick={()=>Globals.auth.logout()}>تسجيل خروج</div>
        </div>
    </div>
  )
}

export default SideBar
